import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Ebene 1",
  viewBox: "0 0 54.5 54.5"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M54.5 27.2C54.5 12.1 42.3 0 27.2 0S0 12.2 0 27.2s12.2 27.3 27.3 27.3 27.2-12.1 27.2-27.3Zm-4.1-1.8-36.3 21v-9.5c0-.5.3-1 .8-1.2l6.1-2.8-6-2.9c-.5-.2-.9-.7-.9-1.2v-8.1l14.7 8.6 3.6-1.6-17.5-10.2c-.4-.2-.8-.7-.8-1.2V8.2l26.4 15.9 3.2-1.4c.8-.3 1.5-.3 2.3.1l4.4 2.6Z",
      style: {"fill":"#0805f2"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "H1-logo"}) } }